import { Component, input } from '@angular/core';
import { GcPillComponent, IpoTranslatePipe } from '@ip-only/front-end-library';

import { Feature, LineString } from 'geojson';
import { SpanProperties } from '../../../../../span-progress-app/span-progress-entities';
import { getIconUrlForStatus } from '../../../../util/report-status-icon-helper';
import { RolloutProgressReportEntities } from '../../../service/entities';
import { ReportInfoItemComponent } from './report-info-item/report-info-item.component';

@Component({
  selector: 'app-report-info-v2',
  imports: [ReportInfoItemComponent, GcPillComponent, IpoTranslatePipe],
  templateUrl: './report-info-v2.component.html',
  styleUrl: './report-info-v2.component.scss',
})
export class ReportInfoV2Component {
  data = input.required<RolloutProgressReportEntities.v3.ReportInfoData>();
  spanPropertiesArray = input<Feature<LineString, SpanProperties>[]>();

  get isReportTypeSpan(): boolean {
    return this.data().type !== 'SPAN';
  }

  get statusIconLink(): string {
    return getIconUrlForStatus(this.data().type, this.data().status);
  }
}
